import { render, staticRenderFns } from "./Logout-Modal.vue?vue&type=template&id=1a7bf23a&"
import script from "./Logout-Modal.vue?vue&type=script&lang=js&"
export * from "./Logout-Modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports